import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { loadEventTasksAsync, selectCurrentPartyFilteredEventTasks, selectDisplayTaskFilter, selectEventTasksFilter, setDisplayTasksFilter, setEventTasksFilter, setLogoutRequested } from './currentPartyEventSlice'
import { useAuth0 } from "@auth0/auth0-react";
import styles from './CurrentPartyEvent.module.css';
import '../../App.css';
import { selectCurrentPartyEvent, selectCurrentPartyWrappedEventTasks, removeEventTaskAsync, selectCurrentPartyLogoutRequested } from './currentPartyEventSlice'
import { Page } from '../../Page'
import { FoodIcon, MoneyIcon, SearchIcon, TaskIcon } from '../../images/Icons';
import { resetButtons, setNotificationsButtonVisible, setInformationButtonVisible, setHomeButtonVisible, setAddEventTaskVisible, setBackButtonVisible, setReloadButtonVisible } from '../menu/menuSlice'
import { associateCurrentEventTask } from '../currentEventTask/currentEventTaskSlice'
import { selectCurrentPartyRefreshRequired} from './currentPartyEventSlice';
import { URLJoin } from '../../utils/urlUtils';
import { callbackUri, isMobile, rootUrl } from '../../AppSettings';
import { sanitizeEmail } from '../../utils/emailUtils';
import {  selectPartyEvents} from '../partyEvents/partyEventsSlice';
import { renderStatus } from '../../utils/enumUtils';
import { transmissionDateToDisplayableDate, transmissionDateToDisplayableTime } from '../../utils/dateUtils';
import { ReloadButton } from '../menu/ReloadPartyEventsButton';
import { DropDownButton } from '../../components/DropDownButton';
import { Browser } from '@capacitor/browser';
import userImg from '../../images/user.svg'
import { NotificationsButton } from '../notifications/notificationsButton';
import { BackButton } from '../menu/BackButton';


export function CurrentPartyEvent() {
    const { user, isAuthenticated, getAccessTokenSilently, logout } = useAuth0()
    const currentPartyEvent = useAppSelector(selectCurrentPartyEvent)
    const wrappedEventTasks = useAppSelector(selectCurrentPartyWrappedEventTasks)
    const filteredEventTasks = useAppSelector(selectCurrentPartyFilteredEventTasks)
    const dateAsString = currentPartyEvent?.start ? transmissionDateToDisplayableDate(currentPartyEvent.start): 'No Date'
    const timeAsString = currentPartyEvent?.start ? transmissionDateToDisplayableTime(currentPartyEvent.start): 'No Time'
    const displayFilter = useAppSelector(selectDisplayTaskFilter)
    const eventTaskFilter = useAppSelector(selectEventTasksFilter)
    const endDateAsString = currentPartyEvent?.end ? transmissionDateToDisplayableDate(currentPartyEvent.end): 'No Date'
    const endtimeAsString =  currentPartyEvent?.end ? transmissionDateToDisplayableTime(currentPartyEvent.end): 'No Time'
    const partyEvents = useAppSelector(selectPartyEvents)
    const refreshRequired = useAppSelector(selectCurrentPartyRefreshRequired)
    const logoutRequested = useAppSelector(selectCurrentPartyLogoutRequested)

    const dispatch = useAppDispatch()
    const navigate = useNavigate()


    const doLogout = async () => {
        dispatch(setLogoutRequested(true))
        await logout({
          async openUrl(url) {
            await Browser.open({
              url,
              windowName: "_self",
            });
          },
          logoutParams: {
            returnTo: callbackUri
          }
        });
      };

    const performDeletionAsync = async (eventTaskId: number) => {
        if (isAuthenticated) {  
            try {
                const accessToken = await getAccessTokenSilently({ authorizationParams : {
                }})
                if (user?.email) {
                    dispatch(removeEventTaskAsync({ 
                        eventTaskId: eventTaskId,
                        userEmail: sanitizeEmail(user?.email),
                        token: accessToken
                    }))
                }
            } catch (error)  {
                console.log(error)
            }
          }
    }
    useEffect(() => {
        dispatch(resetButtons())
        dispatch(setNotificationsButtonVisible(true))
        dispatch(setAddEventTaskVisible(true))
        dispatch(setHomeButtonVisible(true))
        dispatch(setReloadButtonVisible(true))
    }, [dispatch])

    useEffect(() => {
        const getUserMetadata = async () => {
          if (isAuthenticated) {  
            try {
                const accessToken = await getAccessTokenSilently({ authorizationParams : {
                }})
                if (currentPartyEvent?.id) {
                    if (refreshRequired) {
                        dispatch(loadEventTasksAsync({ 
                                        partyEventId: currentPartyEvent.id,
                                        token: accessToken
                                    }))
                            }
                    if (logoutRequested){
                        navigate("/")
                    }
                }
            } catch  {
                console.log("Error occured getting token or getting event tasks");
            }
          }
        };
      
        getUserMetadata();
        
      }, [dispatch, getAccessTokenSilently, isAuthenticated, navigate, currentPartyEvent, refreshRequired, logoutRequested]);

         const buildHyperLink = () => {
            return  URLJoin(window.location.origin,'invitation',currentPartyEvent?.reference ? btoa(currentPartyEvent.reference) : '');
         }

         const mobileHyperLink = () => {
            return URLJoin(rootUrl, "invitation", currentPartyEvent?.reference ? btoa(currentPartyEvent.reference) : '');
         }

    return (
            <Page>
            <div className={styles.controlbanner}>
                <div>
                <h4>{currentPartyEvent?.title}</h4>
                </div>
                <div className={styles.buttoncontainer}>
                <NotificationsButton/>
                <ReloadButton/>
                <DropDownButton imgSrc={userImg} imgAlt="User Menu">
                <div className={styles.linkButton} onClick={doLogout}>Sign out</div>
                <div className={styles.linkButton} onClick={()=> {navigate('/Merchandise')}}>Merchandise</div>
                <div className={styles.linkButton} onClick={() => {navigate('/AccountDetails')}}>Account details</div>
                </DropDownButton>
                </div>
            </div>
            <div className={styles.bannerContainer}>
                <div>
                <h2>PartyPlanner.</h2>
                <h4>Organise, invite and celebrate in style.</h4>
                </div>
                <div className={styles.backButton}>
                <BackButton/>
                <div className={styles.bannerButton} onClick={()=> {
                    dispatch(associateCurrentEventTask({
                        eventTaskType: 0,
                        eventTask: {
                            title: '',
                            id: 0,
                            allocatedUserEmail: '',
                            allocatedUserAlias: '',
                            description: '',
                            notes: '',
                            status: 0
                        }
                    }))
                    navigate('/NameEventTask')
                    }}>
                    Add Task
                </div>
            </div>
            </div>
                <div className={styles.currentEventInfoPanel}>
                    <h2>Event Details</h2>
                    <div className={styles.currentEventSubInfoPanel}>
                        <div className={styles.leftHandPanel}>
                        <p>{currentPartyEvent?.location}</p>
                        <p>Start Date: {dateAsString}</p>
                        <p>Time: {timeAsString} to {endtimeAsString}</p>
                        <p>End Date: {endDateAsString}</p>
                        <div className={styles.editPartyEvent}>
                        {/* <button className={styles.editButton} onClick={(e) => {
                                navigate('/editPartyEvent')
                            }}> Edit</button>
                        {currentPartyEvent?.reference != null && currentPartyEvent.reference.length > 0 ?
                        <>
                        <button className={styles.actionButton} onClick={() => {
                            if (isMobile === true){
                                navigator.clipboard.writeText(mobileHyperLink()) 
                            }
                            else
                            {
                                navigator.clipboard.writeText(buildHyperLink())
                            }
                         
                             }}> 
                                 Copy Invitation Link
                        </button>
                                             </>   : null} */}
                        </div>
                            </div>
                        
                        <div className={styles.currentEventInfo}>
                        <button className={styles.editButton} onClick={(e) => {
                                navigate('/editPartyEvent')
                        }}> Edit Event</button>
                        <br></br>
                        <br></br>
                        <button className={styles.attendeeButton} onClick={() => {
                            navigate('/currentEventUsers')
                        }}>Attendees</button> 
                        </div>
                    </div>
                </div>
                {isAuthenticated && wrappedEventTasks.length > 0 ?
                
                     <div className={styles.titleContainer}>
                            <h3>Event tasks - scroll for more<br></br> (Click on the task for more details)</h3>
                            <h2> Tasks:</h2>
                     <br></br>
                    {/* <div onClick={() => {    
                        dispatch(setDisplayTasksFilter(!displayFilter))}}  
                        className={styles.magnifyingGlass}> <SearchIcon/></div> */}
                    </div>
                     :
                      <span></span>} 
            <span>
                <div className={styles.filterContainer}>
                    <input
                        autoFocus
                        type= 'text'
                        size={60}
                        className={styles.searchFilter}
                        value={eventTaskFilter}
                        placeholder='Search by name'
                        onChange={(e) => {
                            dispatch(setEventTasksFilter(e.target.value))
                        }}>
                     </input>
                </div>
            </span>

                {
                    isAuthenticated && filteredEventTasks?.map((wrappedEventTask) => {
                        switch(wrappedEventTask.eventTaskType) {
                            case 1:
                                return (
                                    <div className='panel-container'>
                                    <div className={styles.foodEventTaskPanel} key={wrappedEventTask.eventTask.id} onClick={ () => {
                                        dispatch(associateCurrentEventTask(wrappedEventTask))
                                        navigate('/editEventTask')
                                    }}>
                                        <div>
                                            <FoodIcon />
                                        </div>
                                        <div className={styles.eventTaskInformation}>
                                            <span>{wrappedEventTask.eventTask.title} </span>
                                            <div className={styles.eventTaskText}>                                            
                                            <span>{wrappedEventTask.eventTask.allocatedUserEmail == null || wrappedEventTask.eventTask.allocatedUserEmail === '' ? <span>Unclaimed as of yet</span> : <span>Allocated to:  
                                                { wrappedEventTask.eventTask.allocatedUserAlias == null || wrappedEventTask.eventTask.allocatedUserAlias === '' ? <span> {wrappedEventTask.eventTask.allocatedUserEmail}</span>  : <span> {wrappedEventTask.eventTask.allocatedUserAlias}</span>}</span>}</span>
                                                </div>
                                            <div>Status: {renderStatus(wrappedEventTask.eventTask.status)}</div>
                                        </div>
                                        <div className={styles.eventTaskButtonPanel}>
                                            
                                            <button className = {styles.deleteTask} onClick={ async(e) => {
                                                e.stopPropagation()
                                                await performDeletionAsync(wrappedEventTask.eventTask.id)} }
                                            >Delete</button>
                                        </div>
                                    </div>
                                    </div>
                                    )
                            case 2:
                                return (
                                    <div className='panel-container'>
                                    <div className={styles.sendMoneyTaskPanelPanel} key={wrappedEventTask.eventTask.id} onClick={ () => {
                                        dispatch(associateCurrentEventTask(wrappedEventTask))
                                        navigate('/editEventTask')
                                    }} >
                                        <div>
                                            <MoneyIcon/>
                                        </div>
                                        <div className={styles.eventTaskInformation}>
                                            <span>{wrappedEventTask.eventTask.title}</span>
                                            <div className={styles.eventTaskText}>
                                            <span>{wrappedEventTask.eventTask.allocatedUserEmail == null || wrappedEventTask.eventTask.allocatedUserEmail === '' ? <span>Unclaimed as of yet</span> : <span>Allocated to:  
                                                { wrappedEventTask.eventTask.allocatedUserAlias == null || wrappedEventTask.eventTask.allocatedUserAlias === '' ? <span> {wrappedEventTask.eventTask.allocatedUserEmail}</span>  : <span> {wrappedEventTask.eventTask.allocatedUserAlias}</span>}</span>}</span>
                                                </div>
                                                <div>Status:{renderStatus(wrappedEventTask.eventTask.status)}</div>

                                        </div>
                                        <div className={styles.eventTaskButtonPanel}>
                                        <button  className = {styles.deleteTask} onClick={ async(e) => {
                                                e.stopPropagation()
                                                await performDeletionAsync(wrappedEventTask.eventTask.id)} }
                                            >Delete</button>
                                        </div>
                                    </div>
                                    </div>
                                    )
                            default:
                                return (
                                    <div className='panel-container'>
                                    <div className={styles.simpleEventTaskPanel} key={wrappedEventTask.eventTask.id} onClick={ () => {
                                        dispatch(associateCurrentEventTask(wrappedEventTask))
                                        navigate('/editEventTask')
                                    }}>
                                        <div>
                                            <TaskIcon/>
                                        </div>
                                        <div className={styles.eventTaskInformation}>
                                            
                                            <span>{wrappedEventTask.eventTask.title}</span>
                                            
                                            <div className={styles.eventTaskText}>
                                            <span>{wrappedEventTask.eventTask.allocatedUserEmail == null || wrappedEventTask.eventTask.allocatedUserEmail === '' ? <span>Unclaimed</span> : <span>Allocated to:  
                                                { wrappedEventTask.eventTask.allocatedUserAlias == null || wrappedEventTask.eventTask.allocatedUserAlias === '' ? <span> {wrappedEventTask.eventTask.allocatedUserEmail}</span>  : <span> {wrappedEventTask.eventTask.allocatedUserAlias}</span>}</span>}</span>
                                                </div>
                                                <div>Status: {renderStatus(wrappedEventTask.eventTask.status)}</div>

                                        </div>
                                        <div className={styles.eventTaskButtonPanel}>
                                        <button className = {styles.deleteTask} onClick={ async(e) => {
                                                e.stopPropagation()
                                                await performDeletionAsync(wrappedEventTask.eventTask.id)} }
                                            >Delete</button>
                                        </div>
                                    </div>
                                    </div>
                                    )
                        }
})
                }
                <br></br>
                {/* <div className={styles.addEventTaskButton2} onClick={()=> {
                    dispatch(associateCurrentEventTask({
                        eventTaskType: 0,
                        eventTask: {
                            title: '',
                            id: 0,
                            allocatedUserEmail: '',
                            allocatedUserAlias: '',
                            description: '',
                            notes: '',
                            status: 0
                        }
                    }))
                    navigate('/NameEventTask')
                }}><p> Add Event Task</p></div> */}
                <br></br>
                <br></br>
                <br></br>
            </Page>
        
    )
}